import { blue, grey, pink } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: blue["A700"],
    },
    secondary: {
      main: pink["A400"],
    },
    grey: {
      main: grey[600],
      light: grey[300],
    },
  },
});
